import {Grid, makeStyles, Theme} from '@logistics-frontend/blocks'
import {CircularProgress} from '@logistics-frontend/blocks/legacy'
import {StickyGrid} from '@logistics-frontend/blocks/lpc/grid'
import {AsyncStatus, useZoneInfoQuery} from '@yandex-taxi/react-integration-api'
import React from 'react'

import {AddPaymentButton, AuthorizationButton, OrderButton} from '../../shared/buttons'
import {useAuthorizationGoal} from '../../shared/metrika'
import {CouponsField} from './coupon'
import {Disclaimer} from './disclaimer'
import {Estimate} from './estimate'
import {Payments} from './payments'
import {Route} from './route'
import {ZoneInfo} from './zone-info'

const orderButton = () => <OrderButton />
const paymentButton = () => <AddPaymentButton>{orderButton}</AddPaymentButton>

const useClasses = makeStyles((theme: Theme) => ({
  orderSubmit: {
    margin: theme.spacing(0, -3),
    padding: theme.spacing(2, 3),
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(0, -1.5),
      padding: theme.spacing(2, 1.5),
    },
  },
}))

const Form: React.FC = () => {
  const classes = useClasses()
  const {data, status} = useZoneInfoQuery()
  useAuthorizationGoal()

  if (status === AsyncStatus.PENDING) {
    return (
      <Grid justify="center" container>
        <CircularProgress size={20} />
      </Grid>
    )
  }

  return (
    <>
      {status === AsyncStatus.SUCCESS ? <ZoneInfo tariffs={data?.max_tariffs || []} /> : null}
      <Route />
      <Estimate />
      <Payments />
      <CouponsField />
      <Disclaimer />
      <StickyGrid className={classes.orderSubmit}>
        <AuthorizationButton>{paymentButton}</AuthorizationButton>
      </StickyGrid>
    </>
  )
}
export default Form
